var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaddedAlternates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 124,
    viewBox: "0 0 343 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H343V124H0V0Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.735 88.2706H148.248L152.216 95.1212H158.703L154.735 88.2706ZM137.594 95.1212H144.188L148.156 88.2706L151.387 82.5925L148.248 77.0791L137.594 95.1212Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.294 86.5603H227.044L226.234 88.1058H224.965L228.676 81.4199L232.276 88.1058H231.099L230.29 86.5603H230.294ZM229.854 85.6591L228.676 83.4935L227.499 85.6591H229.849H229.854Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.744 86.5603H242.493L241.684 88.1058H240.415L244.107 81.4199L247.726 88.1058H246.549L245.739 86.5603H245.744ZM245.284 85.6591L244.107 83.4935L242.929 85.6591H245.279H245.284Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.276 86.5603H160.025L159.216 88.1058H157.947L161.658 81.4199L165.258 88.1058H164.08L163.271 86.5603H163.276ZM162.835 85.6591L161.658 83.4935L160.481 85.6591H162.83H162.835Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.947 84.8555L165.868 81.7839H167.23L168.678 83.9544L170.204 81.7839H171.474L169.303 84.8555L171.566 88.1064H170.296L168.586 85.6646L166.861 88.1064H165.611L167.947 84.8555Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173.566 81.7839H172.481V88.1016H173.566V81.7839Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.245 82.6853L178.344 83.1456C178.16 82.8694 177.995 82.6853 177.811 82.5933C177.719 82.5012 177.443 82.5012 177.166 82.5012C176.91 82.5012 176.633 82.5933 176.449 82.6853C176.173 82.8694 176.081 83.0535 176.081 83.2376C176.081 83.5865 176.357 83.8626 176.91 84.0467L177.719 84.3035C178.344 84.4876 178.712 84.7638 179.08 85.0399C179.337 85.2967 179.429 85.6649 179.429 86.1251C179.429 86.6581 179.245 87.2104 178.804 87.5592C178.252 87.9274 177.719 88.1115 177.002 88.1115C176.357 88.1115 175.824 88.0195 175.369 87.6513C175.02 87.2831 174.744 86.8422 174.652 86.2899L175.737 86.0331C175.829 86.3819 175.921 86.6581 176.013 86.8422C176.27 87.1183 176.638 87.2104 177.079 87.2104C177.447 87.2104 177.724 87.1183 178 86.9342C178.164 86.7501 178.349 86.474 178.349 86.2172C178.349 86.0331 178.257 85.941 178.257 85.849C178.164 85.7569 178.164 85.6649 178.092 85.5728C178 85.4808 177.908 85.3887 177.724 85.2967C177.632 85.2046 177.447 85.224 177.263 85.132L176.546 84.8558C175.461 84.4876 174.928 83.9547 174.928 83.2376C174.928 82.7774 175.185 82.4092 175.645 82.0604C176.013 81.7842 176.546 81.6001 177.263 81.6001C178.092 81.6001 178.809 81.9683 179.25 82.6853H179.245Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276.499 88.0144H277.618V83.4748C277.822 83.7316 278.059 83.9545 278.336 84.1725L283.166 88.0096V81.3577H282.061V85.8779C281.804 85.6211 281.548 85.3643 281.233 85.1269L276.495 81.3625V88.0144H276.499Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M268.544 84.7968L269.353 88.1058H270.491L268.689 81.4199L266.524 85.3152C266.412 85.5186 266.247 85.7948 266.102 86.1436C265.899 85.7027 265.753 85.4266 265.7 85.3152L263.496 81.4199L261.732 88.1058H262.851L263.66 84.7968C263.714 84.5206 263.772 84.2444 263.791 83.9538C263.883 84.2299 264.014 84.4867 264.159 84.7435L266.107 88.1058L268.055 84.7968C268.239 84.5206 268.35 84.2444 268.403 83.9538C268.476 84.414 268.515 84.6902 268.549 84.7968H268.544Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M256.839 88.1058H260.991V87.1514H258.036V85.0391H260.991V84.1185H258.036V82.4859H260.991V81.5847H256.839V88.1058Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M271.223 88.1058H275.375V87.1514H272.439V85.0391H275.375V84.1185H272.439V82.4859H275.375V81.5847H271.223V88.1058Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M252.338 84.6711V85.5529H254.194V85.6449C254.194 86.58 253.331 87.1711 251.897 87.1711C250.226 87.1711 249.068 86.1973 249.068 84.7632C249.068 83.3291 250.245 82.3747 251.878 82.3747C252.687 82.3747 253.331 82.6121 253.845 83.1111L254.765 82.5394C254.029 81.7885 253.074 81.4348 251.863 81.4348C250.725 81.4348 249.698 81.7643 248.942 82.3553C248.172 82.9803 247.765 83.8088 247.765 84.7632C247.765 85.7176 248.167 86.5655 248.884 87.1711C249.635 87.796 250.608 88.1061 251.858 88.1061C254.102 88.1061 255.405 87.079 255.405 85.2767C255.405 85.1314 255.385 84.9279 255.385 84.6711H252.338Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M233.012 88.1977H234.132V83.6436C234.335 83.9004 234.572 84.1232 234.849 84.3412L239.679 88.1977V81.5312H238.56V86.0515C238.322 85.7947 238.046 85.5379 237.751 85.3005L233.012 81.5361V88.2025V88.1977Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M222.523 84.7968L223.352 88.1058H224.471L222.669 81.4199L220.518 85.3152C220.406 85.5186 220.222 85.7948 220.077 86.1436C219.873 85.7027 219.747 85.4266 219.675 85.3152L217.47 81.4199L215.707 88.1058H216.826L217.635 84.7968C217.708 84.5206 217.766 84.2444 217.766 83.9538C217.858 84.2299 217.984 84.4867 218.134 84.7435L220.082 88.1058L222.049 84.7968C222.213 84.5206 222.325 84.2444 222.378 83.9538C222.451 84.414 222.489 84.6902 222.523 84.7968Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M210.382 82.4859H212.345V81.5847H207.185V82.4859H209.166V88.1058H210.382V82.4859Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M286.95 82.4859H288.917V81.5847H283.752V82.4859H285.738V88.1058H286.95V82.4859Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M202.427 88.1058H206.599V87.1514H203.638V85.0391H206.599V84.1185H203.638V82.4859H206.599V81.5847H202.427V88.1058Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.128 86.5603H185.877L185.068 88.1058H183.799L187.51 81.4199L191.109 88.1058H189.932L189.123 86.5603H189.128ZM188.687 85.6591L187.51 83.4935L186.332 85.6591H188.682H188.687Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.998 82.6853L195.077 83.1456C194.913 82.8694 194.729 82.6853 194.545 82.5933C194.452 82.5012 194.176 82.5012 193.92 82.5012C193.643 82.5012 193.367 82.5933 193.183 82.6853C192.926 82.8694 192.834 83.0535 192.834 83.2376C192.834 83.5865 193.091 83.8626 193.643 84.0467L194.452 84.3035C195.077 84.4876 195.446 84.7638 195.814 85.0399C196.071 85.2967 196.163 85.6649 196.163 86.1251C196.163 86.6581 195.998 87.2104 195.538 87.5592C195.005 87.9274 194.452 88.1115 193.735 88.1115C193.091 88.1115 192.558 88.0195 192.103 87.6513C191.754 87.2831 191.478 86.8422 191.386 86.2899L192.471 86.0331C192.563 86.3819 192.655 86.6581 192.747 86.8422C193.023 87.1183 193.372 87.2104 193.832 87.2104C194.181 87.2104 194.457 87.1183 194.734 86.9342C194.918 86.7501 195.082 86.474 195.082 86.2172C195.082 86.0331 195.01 85.941 195.01 85.849C194.918 85.7569 194.918 85.6649 194.826 85.5728C194.733 85.4808 194.641 85.3887 194.457 85.2967C194.365 85.2046 194.181 85.224 194.016 85.132L193.28 84.8558C192.195 84.4876 191.662 83.9547 191.662 83.2376C191.662 82.7774 191.938 82.4092 192.379 82.0604C192.747 81.7842 193.28 81.6001 194.012 81.6001C194.821 81.6001 195.538 81.9683 195.998 82.6853Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M201.361 82.6853L200.46 83.1456C200.276 82.8694 200.092 82.6853 199.908 82.5933C199.816 82.5012 199.559 82.5012 199.283 82.5012C199.007 82.5012 198.731 82.5933 198.566 82.6853C198.29 82.8694 198.198 83.0535 198.198 83.2376C198.198 83.5865 198.474 83.8626 199.007 84.0467L199.816 84.3035C200.46 84.4876 200.809 84.7638 201.177 85.0399C201.453 85.2967 201.545 85.6649 201.545 86.1251C201.545 86.6581 201.361 87.2104 200.901 87.5592C200.368 87.9274 199.816 88.1115 199.099 88.1115C198.474 88.1115 197.922 88.0195 197.481 87.6513C197.112 87.2831 196.836 86.8422 196.744 86.2899L197.829 86.0331C197.922 86.3819 198.014 86.6581 198.106 86.8422C198.382 87.1183 198.731 87.2104 199.191 87.2104C199.559 87.2104 199.816 87.1183 200.092 86.9342C200.276 86.7501 200.46 86.474 200.46 86.2172C200.46 86.0331 200.368 85.941 200.368 85.849C200.276 85.7569 200.276 85.6649 200.184 85.5728C200.092 85.4808 200 85.3887 199.816 85.2967C199.724 85.2046 199.559 85.224 199.375 85.132L198.639 84.8558C197.573 84.4876 197.02 83.9547 197.02 83.2376C197.02 82.7774 197.297 82.4092 197.737 82.0604C198.106 81.7842 198.639 81.6001 199.37 81.6001C200.179 81.6001 200.896 81.9683 201.357 82.6853H201.361Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M126.306 81.9434V84.8793C126.62 84.5499 126.984 84.3851 127.381 84.3851C127.841 84.3851 128.229 84.5596 128.534 84.9084C128.839 85.2524 128.994 85.6835 128.994 86.1971C128.994 86.7106 128.839 87.1709 128.529 87.5149C128.224 87.8589 127.832 88.0333 127.367 88.0333C126.969 88.0333 126.616 87.8783 126.306 87.573V87.9364H125.516V81.9434H126.306ZM128.19 86.231C128.19 85.9016 128.103 85.6303 127.924 85.4219C127.744 85.2088 127.517 85.1022 127.245 85.1022C126.955 85.1022 126.717 85.2039 126.533 85.4122C126.354 85.6157 126.262 85.8822 126.262 86.2068C126.262 86.5314 126.349 86.8124 126.528 87.011C126.708 87.2145 126.94 87.3211 127.231 87.3211C127.507 87.3211 127.735 87.2194 127.914 87.011C128.098 86.8027 128.19 86.5411 128.19 86.231Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M130.787 87.2926L129.246 84.4778H130.167L131.213 86.4641L132.192 84.4778H133.088L130.356 89.8119H129.45L130.787 87.2878V87.2926Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6966 50.8937L39.971 57.8266H35.601L51.1867 29L66.7724 57.8266H62.4024L58.6768 50.8937H43.6966ZM51.1867 36.5531L45.3875 47.7397H56.9908L51.1915 36.5531H51.1867Z",
    fill: "url(#paint0_linear_5636_177643)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1202 54.6725H88.4531V57.8265H71.0505V30.1724H75.1202V54.6725Z",
    fill: "url(#paint1_linear_5636_177643)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1165 57.8265H95.0469V33.3263H85.585V30.1724H108.574V33.3263H99.1117V57.8265H99.1165Z",
    fill: "url(#paint2_linear_5636_177643)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M113.515 30.1724H131.048V33.3263H117.585V41.0635H130.661V44.2175H117.585V54.6725H131.048V57.8265H113.515V30.1724Z",
    fill: "url(#paint3_linear_5636_177643)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M157.622 57.8265H152.686L143.073 46.1263H141.383V57.8265H137.313V30.1724H142.25C145.152 30.1724 148.267 30.2111 150.864 31.4562C153.592 32.8128 155.152 35.4193 155.152 38.0597C155.152 42.0228 152.036 45.3221 147.318 45.7969L157.622 57.8265ZM141.387 43.2679H142.686C146.843 43.2679 151.344 42.609 151.344 38.2051C151.344 33.8011 146.494 33.2537 142.468 33.2537H141.387V43.2679Z",
    fill: "url(#paint4_linear_5636_177643)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M162.743 29.7073L184.68 50.6029V30.1724H188.75V58.9651L166.813 38.0694V58.6841H162.743V29.7073Z",
    fill: "url(#paint5_linear_5636_177643)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M201.327 50.8937L197.602 57.8266H193.232L208.817 29L224.403 57.8266H220.033L216.308 50.8937H201.327ZM208.817 36.5531L203.018 47.7397H214.622L208.822 36.5531H208.817Z",
    fill: "url(#paint6_linear_5636_177643)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M232.703 57.8265H228.633V33.3263H219.171V30.1724H242.16V33.3263H232.698V57.8265H232.703Z",
    fill: "url(#paint7_linear_5636_177643)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M246.437 30.1724H263.971V33.3263H250.507V41.0635H263.583V44.2175H250.507V54.6725H263.971V57.8265H246.437V30.1724Z",
    fill: "url(#paint8_linear_5636_177643)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M284.629 35.4191C283.418 33.6943 281.858 32.8126 279.392 32.8126C276.795 32.8126 273.937 34.3145 273.937 36.7369C273.937 38.9025 276.446 40.0362 278.481 40.6999L280.816 41.4702C285.448 43.0109 288.912 45.1765 288.912 49.7936C288.912 54.8177 284.324 58.4125 278.476 58.4125C273.195 58.4125 269.082 55.1132 268.389 50.6754L272.503 49.9438C272.459 52.9864 275.317 55.1907 278.825 55.1907C282.333 55.1907 284.842 52.6957 284.842 49.7985C284.842 46.9013 282.027 45.5447 279.213 44.5515L276.96 43.7425C273.234 42.3859 269.862 40.5885 269.862 36.7369C269.862 32.2603 274.537 29.5859 279.474 29.5859C283.113 29.5859 286.097 31.0878 287.875 33.767L284.629 35.4191Z",
    fill: "url(#paint9_linear_5636_177643)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M271.073 62.7659H33.1594L30.7951 67.1359H286.548L288.912 62.7659H271.073Z",
    fill: "url(#paint10_linear_5636_177643)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M309.231 62.7655L311.595 58.3955H291.276L288.912 62.7655H309.231Z",
    fill: "url(#paint11_linear_5636_177643)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5636_177643",
    x1: 373.822,
    y1: -32.6889,
    x2: -7.2562,
    y2: 59.4254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5636_177643",
    x1: 375.106,
    y1: -27.3936,
    x2: -5.97704,
    y2: 64.7207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5636_177643",
    x1: 375.799,
    y1: -24.5158,
    x2: -5.28422,
    y2: 67.5985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5636_177643",
    x1: 377.451,
    y1: -17.6798,
    x2: -3.62744,
    y2: 74.4345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5636_177643",
    x1: 378.841,
    y1: -11.929,
    x2: -2.24168,
    y2: 80.1854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5636_177643",
    x1: 380.479,
    y1: -5.15111,
    x2: -0.599543,
    y2: 86.9633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5636_177643",
    x1: 382.523,
    y1: 3.30798,
    x2: 1.4452,
    y2: 95.4223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_5636_177643",
    x1: 383.173,
    y1: 5.99193,
    x2: 2.09453,
    y2: 98.1063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_5636_177643",
    x1: 384.79,
    y1: 12.6778,
    x2: 3.70754,
    y2: 104.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_5636_177643",
    x1: 386.104,
    y1: 18.1086,
    x2: 5.0206,
    y2: 110.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_5636_177643",
    x1: 385.149,
    y1: 10.2095,
    x2: 4.06639,
    y2: 102.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_5636_177643",
    x1: 391.966,
    y1: 38.4107,
    x2: 10.8832,
    y2: 130.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#976427"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#AB7E31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#B88F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#BF9948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D4B56E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E8D193"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#CBAA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#AD8F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95762C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddedAlternates);
export default __webpack_public_path__ + "static/media/PaddedAlternates.2f8ca1471d16d8170fea118f4cfbff94.svg";
export { ForwardRef as ReactComponent };